import { SupportedLocaleEnum } from 'localization';
import { ProductItem } from 'lane-shared/domains/billingPayments/types';
import {
  type SupportedPaymentCurrency,
  getCurrencyPrecision,
} from 'domains-billing-currency';
import { getPricing } from '../../productCatalog/helpers';
import { PriceComponents } from '../../productCatalog/types';
import BigNumber from 'bignumber.js';

export function getDraftTotalAmounts(
  listOfProducts: ProductItem[],
  currency: SupportedPaymentCurrency,
  locale: SupportedLocaleEnum
) {
  const precision = getCurrencyPrecision(currency);

  let subTotal = new BigNumber(0);
  let tax = new BigNumber(0);
  let total = new BigNumber(0);

  listOfProducts.forEach(productItem => {
    const priceComponents: PriceComponents = {
      amount: productItem.product.amount,
      markup: productItem.product.markup,
      tax: productItem.product.tax,
      netPrice: productItem.product.netPrice,
      sellingPrice: productItem.product.sellingPrice,
    };
    const { listPrice, grossTax, netPrice } = getPricing({
      currency,
      locale,
      priceComponents,
    });

    const quantity = new BigNumber(productItem.quantity);

    subTotal = subTotal.plus(new BigNumber(listPrice).multipliedBy(quantity));
    tax = tax.plus(new BigNumber(grossTax).multipliedBy(quantity));
    total = total.plus(new BigNumber(netPrice).multipliedBy(quantity));
  });

  return {
    subTotal: subTotal.decimalPlaces(precision, BigNumber.ROUND_UP).toNumber(),
    tax: tax.decimalPlaces(precision, BigNumber.ROUND_UP).toNumber(),
    total: total.decimalPlaces(precision, BigNumber.ROUND_UP).toNumber(),
  };
}
